import React  from 'react';
import ActivateAccountComp from '../components/Users/activateAccountComp';
function ActivateAccount() {
  return (
    <>
    <ActivateAccountComp />
    </>
  );
}

export default ActivateAccount;
